import * as React from 'react'

import { PostsGroupHeaderDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

type Props = {
  groupId: number
  value: number[]
  onChange: (ids: number[]) => void
  disabled?: boolean
}

function InviteMembersView({ groupId, value, onChange, disabled }: Props) {
  const { data } = useQuery(PostsGroupHeaderDocument, {
    variables: { id: groupId },
  })

  const currentMemberIds = React.useMemo(() => {
    return data?.posts?.group?.employees?.map((employee) => employee.id) ?? []
  }, [data])

  const forcedFilters = React.useMemo(() => {
    return {
      excludeIds: currentMemberIds,
      excludeCurrentEmployee: true,
    }
  }, [currentMemberIds])

  const handleEmployeeChange = React.useCallback(
    (state: EmployeeSelectorV2MultiSelectState) => {
      if (state.type === 'manual') {
        onChange(state.ids)
      }
    },
    [onChange]
  )

  return (
    <EmployeeSelectorV2
      multiple
      value={value}
      onChange={handleEmployeeChange}
      forcedFilters={forcedFilters}
      disabled={disabled}
      options={{ disableSelectAll: true, asList: true, hideLabel: true }}
    />
  )
}

export default InviteMembersView
